import Scrollbars, { ScrollbarRef } from './scrollbars'

export { Scrollbars }
export type { ScrollbarRef }
